const bgColors = [
    "#E3F2FD", "#FFF3E0", "#E8F5E9", "#F3E5F5", "#E0F7FA", "#FFFDE7", "#FBE9E7"
];
const textColors = [
    "#1565C0", "#EF6C00", "#2E7D32", "#6A1B9A", "#00838F", "#F9A825", "#D84315"
];

const getColorSet = (str) => {
    if (!str) return { bg: "#e0e0e0", color: "#333" };
    const index = str.charCodeAt(0) % bgColors.length;
    return { bg: bgColors[index], color: textColors[index] };
};

const UserAvatar = ({ username = "", image = "", style = {}, className = "", size = 30, fontSize = "12px", marginRight = "2px" }) => {
    const initials = username
        ? username.split(" ").map((w) => w[0]).join("").toUpperCase().slice(0, 2)
        : "";

    const { bg, color } = getColorSet(username);

    return image ? (
        <img
            className={`user_icon_img ${className}`}
            src={`${process.env.REACT_APP_API_FILES_URL}${image}`}
            alt="User Avatar"
            style={{
                marginRight: marginRight,
                borderRadius: "50%",
                width: `${size}px`,
                height: `${size}px`,
                ...style,
            }}
        />
    ) : (
        <div
            className={`user_icon_img ${className}`}
            style={{
                marginRight: marginRight,
                background: bg,
                color: color,
                fontWeight: "500",
                fontSize: fontSize,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: `${size}px`,
                height: `${size}px`,
                ...style,
            }}
        >
            {initials}
        </div>
    );
};

export default UserAvatar;
